/** The ACL editor's notice states (S8 Task 8.11) and which of them keep Save off until Reload. */
import type { StorageOperationError } from '../../../../../types/azureStorage';

export type AclEditorFeedback =
  | { kind: 'path-changed' | 'acl-changed' | 'ambiguous' | 'refused' | 'error'; error: StorageOperationError }
  | { kind: 'server-changed' };

export const feedbackBlocksSave = (feedback: AclEditorFeedback | undefined): boolean =>
  feedback?.kind === 'path-changed' || feedback?.kind === 'acl-changed' || feedback?.kind === 'ambiguous' || feedback?.kind === 'server-changed';
